export const BASE_CONFIGURATION = {
  Header: {
    Action: 'A',
    Application: 'ACTUA',
    Control: 'IMAWEB',
    Version: '3',
    Reference: 'AU-00091-VN-2259-1742311072756',
    ReturnUrl:
      'https://audi.imaweb.net/app-16.12.2202/myrenting/my_renting.preProcess?product_family=FI',
    OfferType: null,
    IBANVirtual: null,
    Language: null,
    Token: null,
  },
  Client: {
    Class: null,
    Name: '',
    Surname1: '',
    Surname2: '',
    Ident: '',
  },
  Dealer: {
    Code: 'martin.leal2',
    Ident: 'A80185051',
    Name: 'Martin',
    Surname1: 'Leal',
    Surname2: null,
    UserId: 'ANTA438',
    EmpleadoId: 15487,
  },
  Dealership: {
    Code: '00093',
  },
  Vehicle: {
    Type: 'VN',
    Purpose: 1,
    IdOffer: null,
    IdUser: null,
    TMAIMGVE: null,
    TMAIMG: 'F3NAYC',
    ModelYear: '2025',
    Color: {
      Code: 'Q0Q0',
      Name: 'Pinturas Personalizadas, Audi Exclusive',
      Description: null,
      Amount: 231396,
      Type: null,
      IsFree: true,
    },
    Seating: {
      Code: 'FZ',
      Name: 'Negro-Negro/Negro-Negro/Negro/Plata Luna',
      Description: null,
      Amount: 0,
      Type: null,
      IsFree: true,
    },
    EmiNEDC: 150,
    Emi: null,
    EmiWLTP: 150,
    PffAmount: 3780495,
    OptAmount: 289896,
    AccAmount: 0,
    RegAmount: 0,
    RegTax: 0,
    TransAmount: 25000,
    DepositAmount: null,
    InitAmount: 0,
    DisAmount: 0,
    DisAmount2: 0,
    PVP: 5209954,
    BrandGroup: 0,
    BrandGroupCode: null,
    Brand: null,
    BrandCode: null,
    ComDenom: 'Audi Q3 Sportback Advanced 35 TFSI  110(150) kW(CV) 6 vel. [2025]',
    Segment: '35262',
    SalesGr: '51225',
    NatSalPro: '',
    Version: '0',
    CodISet: '',
    InitKm: null,
    RegDate: null,
    Frame: null,
    NReg: null,
    PorDisAmount: 0,
    PorDisAmount2: 0,
    Power: null,
    Energy: null,
    Location: null,
    VehicleId: 0,
    DiscPercentStandard: null,
    DiscPercentAdditional: null,
    BrandEnum: {},
    CampainMat: null,
    PrSerieMat: [],
    OptionalMat: [],
    AccesoryMat: [],
    OptionalExcMat: [],
    OptExcAmount: 0,
    ExcOptionalMats: [{ FI: [] }, { RE: [] }],
    ExcCampaigns: [{ FI: [] }, { RE: [] }],
    prodsaDS: '',
    RegTaxAmount: 194531,
    RegTaxPercentage: 4750,
    OtherInBaseAmount: 0,
    OtherOutBaseAmount: 0,
    IvaTaxAmount: 860032,
    IvaTaxPercentage: 21,
    PreDeliveryAmount: 0,
  },
};

export const HIDDEN_FIELD_DEFINITIONS = [
  { path: 'Vehicle.BrandEnum', defaultValue: {} },
  { path: 'Vehicle.CampainMat', defaultValue: null },
  { path: 'Vehicle.PrSerieMat', defaultValue: [] },
  { path: 'Vehicle.OptionalMat', defaultValue: [] },
  { path: 'Vehicle.AccesoryMat', defaultValue: [] },
  { path: 'Vehicle.OptionalExcMat', defaultValue: [] },
  { path: 'Vehicle.OptExcAmount', defaultValue: 0 },
  { path: 'Vehicle.ExcOptionalMats', defaultValue: [{ FI: [] }, { RE: [] }] },
  { path: 'Vehicle.ExcCampaigns', defaultValue: [{ FI: [] }, { RE: [] }] },
  { path: 'Vehicle.prodsaDS', defaultValue: '' },
];

export const HIDDEN_FIELD_PATHS = new Set(
  HIDDEN_FIELD_DEFINITIONS.map(({ path }) => path),
);

export const HIDDEN_MAT_ARRAY_FIELDS = new Set([
  'Vehicle.CampainMat',
  'Vehicle.PrSerieMat',
  'Vehicle.OptionalMat',
  'Vehicle.AccesoryMat',
  'Vehicle.OptionalExcMat',
]);

export const HIDDEN_FAMILY_ARRAY_FIELDS = new Set([
  'Vehicle.ExcOptionalMats',
  'Vehicle.ExcCampaigns',
]);

export const SELECT_OPTIONS = {
  'Header.Action': [
    { value: 'A', label: 'A' },
    { value: 'O', label: 'O' },
    { value: 'OD', label: 'OD' },
    { value: 'TE', label: 'TE' },
    { value: 'RO', label: 'RO' },
    { value: 'R8', label: 'R8' },
  ],
  'Header.Application': [
    { value: 'SIM', label: 'SIM' },
    { value: 'SAM', label: 'SAM' },
    { value: 'SKODA', label: 'SKODA' },
    { value: 'ACTUA', label: 'ACTUA' },
    { value: 'IMPULSO', label: 'IMPULSO' },
    { value: 'COSMOS', label: 'COSMOS' },
    { value: 'POSPR', label: 'POSPR' },
    { value: 'SACU', label: 'SACU' },
    { value: 'SAAU', label: 'SAAU' },
    { value: 'SASE', label: 'SASE' },
    { value: 'DAVW', label: 'DAVW' },
    { value: 'DAAU', label: 'DAAU' },
    { value: 'DASK', label: 'DASK' },
    { value: 'DALCV', label: 'DALCV' },
  ],
  'Header.Control': [
    { value: 'IMAWEB', label: 'IMAWEB' },
    { value: 'DAG', label: 'DAG' },
    { value: 'FIRED', label: 'FIRED' },
    { value: 'FSOV', label: 'FSOV' },
    { value: 'SALESASSIST', label: 'SALESASSIST' },
    { value: 'POS', label: 'POS' },
  ],
  'Header.Version': [
    { value: '1', label: '1 - Renting' },
    { value: '3', label: '3 - Financiación' },
    { value: '7', label: '7 - Leasing' },
    { value: '6', label: '6 - Productos Adicionales' },
  ],
  'Header.Language': [
    { value: null, label: 'Sin valor' },
    { value: 'es', label: 'es' },
    { value: 'en', label: 'en' },
  ],
  'Vehicle.Type': [
    { value: 'VN', label: 'VN - Nuevo' },
    { value: 'VO', label: 'VO - Usado' },
  ],
  'Vehicle.Purpose': [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
  ],
  'Vehicle.ModelYear': [
    { value: '2025', label: '2025' },
    { value: '2026', label: '2026' },
    { value: '2027', label: '2027' },
  ],
};

export const NUMBER_FIELDS = new Set([
  'Dealer.EmpleadoId',
  'Vehicle.Purpose',
  'Vehicle.EmiNEDC',
  'Vehicle.EmiWLTP',
  'Vehicle.PffAmount',
  'Vehicle.OptAmount',
  'Vehicle.AccAmount',
  'Vehicle.RegAmount',
  'Vehicle.RegTax',
  'Vehicle.TransAmount',
  'Vehicle.InitAmount',
  'Vehicle.DisAmount',
  'Vehicle.DisAmount2',
  'Vehicle.PVP',
  'Vehicle.BrandGroup',
  'Vehicle.PorDisAmount',
  'Vehicle.PorDisAmount2',
  'Vehicle.VehicleId',
  'Vehicle.RegTaxAmount',
  'Vehicle.RegTaxPercentage',
  'Vehicle.OtherInBaseAmount',
  'Vehicle.OtherOutBaseAmount',
  'Vehicle.IvaTaxAmount',
  'Vehicle.IvaTaxPercentage',
  'Vehicle.PreDeliveryAmount',
]);

export const NULLABLE_FIELDS = new Set([
  'Header.OfferType',
  'Header.IBANVirtual',
  'Header.Language',
  'Header.Token',
  'Client.Class',
  'Dealer.Surname2',
  'Vehicle.IdOffer',
  'Vehicle.IdUser',
  'Vehicle.TMAIMGVE',
  'Vehicle.Emi',
  'Vehicle.DepositAmount',
  'Vehicle.BrandGroupCode',
  'Vehicle.Brand',
  'Vehicle.BrandCode',
  'Vehicle.InitKm',
  'Vehicle.RegDate',
  'Vehicle.Frame',
  'Vehicle.NReg',
  'Vehicle.Power',
  'Vehicle.Energy',
  'Vehicle.Location',
  'Vehicle.DiscPercentStandard',
  'Vehicle.DiscPercentAdditional',
]);

export const BOOLEAN_FIELDS = new Set([
  'Vehicle.Color.IsFree',
  'Vehicle.Seating.IsFree',
  'Vehicle.PrSerieMat.*.IsFree',
  'Vehicle.OptionalMat.*.IsFree',
]);

export const EMPTY_HIDDEN_MAT_DRAFT = {
  Code: '',
  Name: '',
  Description: '',
  Amount: 0,
  Type: '',
  IsFree: true,
};